export default __webpack_public_path__ + "static/media/el11.798c3496.svg";